import {
    DetailsFrameBase,
    DetailsColumn,
    DetailsRow,
    DetailsFrameBaseProps,
    ConditionalRender,
} from 'components/atoms';
import { InstitutionBaseDataIcon } from 'assets';
import { subscriptionsTexts } from 'consts/text';
import { InstitutionType } from 'types';
import { InstitutionAffiliationDisplay, InstitutionTypeDisplay } from 'components/molecules/Table';

// eslint-disable-next-line
type InstitutionDataProps = Pick<DetailsFrameBaseProps<any>, 'className'> & {
    regon?: string;
    name: string;
    rspo?: string;
    nurseryRegisterNumber?: string;
    publicInstitution: boolean;
    type: InstitutionType;
};

export const InstitutionData = ({
    regon,
    name,
    rspo,
    nurseryRegisterNumber,
    publicInstitution,
    type,
    className,
}: InstitutionDataProps) => (
    <DetailsFrameBase
        icon={<InstitutionBaseDataIcon />}
        title={subscriptionsTexts.details.institutionData.heading}
        className={className}
    >
        <ConditionalRender condition={!!regon}>
            <DetailsRow>
                <DetailsColumn
                    title={subscriptionsTexts.details.institutionData.regonNumber}
                    span={24}
                >
                    {regon}
                </DetailsColumn>
            </DetailsRow>
        </ConditionalRender>
        <DetailsRow>
            <DetailsColumn
                title={subscriptionsTexts.details.institutionData.institutionName}
                span={24}
            >
                {name}
            </DetailsColumn>
        </DetailsRow>
        <ConditionalRender condition={!!rspo}>
            <DetailsRow>
                <DetailsColumn
                    title={subscriptionsTexts.details.institutionData.rspoNumber}
                    span={24}
                >
                    {rspo}
                </DetailsColumn>
            </DetailsRow>
        </ConditionalRender>
        <ConditionalRender condition={!!nurseryRegisterNumber}>
            <DetailsRow>
                <DetailsColumn
                    title={subscriptionsTexts.details.institutionData.nurseryRegisterNumber}
                    span={24}
                >
                    {nurseryRegisterNumber}
                </DetailsColumn>
            </DetailsRow>
        </ConditionalRender>
        <DetailsRow>
            <DetailsColumn
                title={subscriptionsTexts.details.institutionData.institutionAffiliation}
                span={12}
            >
                <InstitutionAffiliationDisplay isPublicInstitution={publicInstitution} />
            </DetailsColumn>
            <DetailsColumn
                title={subscriptionsTexts.details.institutionData.institutionType}
                span={12}
            >
                <InstitutionTypeDisplay type={type} />
            </DetailsColumn>
        </DetailsRow>
    </DetailsFrameBase>
);
